(() => {
  function initMenus(root = document) {
    root.querySelectorAll('details[data-menu], details.nav-dropdown').forEach(menu => {
      if (menu.dataset.bound) return;
      menu.dataset.bound = 'true';
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
      });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
    });
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('details[data-menu][open], details.nav-dropdown[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  initMenus();
  document.addEventListener('shopify:section:load', event => initMenus(event.target));
})();
